"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wasCallACallback = void 0;
function wasCallACallback(call) {
    return call.duration_events.some(event => event.description === 'CALLBACK_INITIATED');
}
exports.wasCallACallback = wasCallACallback;
